module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/related/ja/1-fd6a515b520b38a041af256a86d84a76.jpg";